import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { AbortReason, Experiences, LoadingState, SloFailureReason } from '@atlassian/notification-common/types';
var isServerFailure = function isServerFailure(statusCode) {
  return statusCode >= 500 && statusCode <= 599;
};
export default function handleExperienceFailures(experienceTracker, loadingStates, withoutContentError, withContentError) {
  if (loadingStates.withContent === LoadingState.ERROR) {
    var withContentErrorCode = withContentError.code || undefined;
    if (withContentErrorCode && isServerFailure(withContentErrorCode)) {
      experienceTracker.fail({
        name: Experiences.RENDER_NOTIFICATIONS_WITH_CONTENT,
        error: new Error(SloFailureReason.FETCH_FAILED),
        attributes: _objectSpread({
          failureReason: SloFailureReason.FETCH_FAILED
        }, withContentErrorCode && {
          statusCode: withContentErrorCode
        })
      });
    } else {
      experienceTracker.abort({
        name: Experiences.RENDER_NOTIFICATIONS_WITH_CONTENT,
        reason: AbortReason.CLIENT_ERROR,
        attributes: _objectSpread({}, withContentErrorCode && {
          statusCode: withContentErrorCode
        })
      });
    }
    if (loadingStates.withoutContent === LoadingState.ERROR) {
      var withoutContentErrorCode = withoutContentError.code || undefined;
      if (withoutContentErrorCode && isServerFailure(withoutContentErrorCode)) {
        experienceTracker.fail({
          name: Experiences.RENDER_NOTIFICATIONS_WITHOUT_CONTENT,
          error: new Error(SloFailureReason.FETCH_FAILED),
          attributes: _objectSpread({
            failureReason: SloFailureReason.FETCH_FAILED
          }, withoutContentErrorCode && {
            statusCode: withoutContentErrorCode
          })
        });
      } else {
        experienceTracker.abort({
          name: Experiences.RENDER_NOTIFICATIONS_WITHOUT_CONTENT,
          reason: AbortReason.CLIENT_ERROR,
          attributes: _objectSpread({}, withoutContentErrorCode && {
            statusCode: withoutContentErrorCode
          })
        });
      }
    }
  }
}